<template>
  <div @mouseenter="isTaskOptionsButtonShown = true" @mouseleave="isTaskOptionsButtonShown = false">
    <b-row>
      <b-col class="col-1 center-align-icon">
        <font-awesome-icon v-if="!taskDetails.completed" class="task-completed-toggle" :icon="['far', 'circle']"
                           @click="toggleTaskCompleted"/>
        <font-awesome-icon v-else class="task-completed-toggle" :icon="['fas', 'check-circle']"
                           @click="toggleTaskCompleted"/>
      </b-col>
      <b-col class="task-details-click-area" @click="showTaskDetailsModal = true">
        <p class="task-name-text" :class="{'completed-task-text': taskDetails.completed}">{{ taskDetails.taskName }}</p>
      </b-col>
      <b-col class="col-1 center-align-icon">
        <font-awesome-icon v-if="taskDetails.priority === 0" class="task-priority-icon" icon="exclamation"
                           @click="showTaskDetailsModal"/>
        <font-awesome-icon v-else-if="taskDetails.priority === 2" class="task-priority-icon" icon="arrow-down"
                           @click="showTaskDetailsModal"/>
      </b-col>
      <b-col class="col-2 center-align-icon">
        <font-awesome-icon v-if="isTaskOptionsButtonShown" class="task-option-button" :icon="['far', 'edit']"
                           @click="showTaskDetailsModal = true"/>
        <font-awesome-icon v-if="isTaskOptionsButtonShown" class="task-option-button" :icon="['far', 'trash-alt']"
                           @click="showDeleteTaskModal = true"/>
      </b-col>
    </b-row>
    <hr>

    <!-- Task Details Modal -->
    <b-modal
        id="task-details-modal"
        title="Personal Task Details"
        :visible="showTaskDetailsModal"
        @hide="showTaskDetailsModal = false"
        scrollable
        no-close-on-backdrop
        hide-footer>
      <personal-task-details :personal-task-details="taskDetails"></personal-task-details>
    </b-modal>

    <!-- Task Options Modal -->
    <b-modal
        id="delete-task-modal"
        title="Delete Task"
        :visible="showDeleteTaskModal"
        @hide="showDeleteTaskModal = false"
        @ok="deleteTask(taskDetails.taskId)"
        scrollable
        ok-only
        ok-title="Delete task"
        ok-variant="danger"
        no-close-on-backdrop>
      <p class="delete-task-text">Are you sure do you want to delete <strong>"{{ taskDetails.taskName }}"</strong> from
        the list?</p>
    </b-modal>


  </div>
</template>

<script>
  import PersonalTaskDetails from "../../task_details_templates/PersonalTaskDetails";
  import {storage, db} from "../../../main";

  export default {
    name: "PersonalTaskCell",
    props: {
      taskDetails: Object
    },
    components: {
      personalTaskDetails: PersonalTaskDetails
    },
    data() {
      return {
        isTaskOptionsButtonShown: false,
        showTaskDetailsModal: false,
        showDeleteTaskModal: false,
        isUndoTaskDeletionClicked: false
      }
    },
    methods: {
      deleteTask(taskId) {
        if (this.$route.name === 'Inbox') {
          db
            .collection('inbox_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .doc(taskId)
            .get()
            .then(doc => {
              // pass the image object for image deletion operation
              const attachmentObject = doc.data().attachment
              this.openTaskDeletionToast(attachmentObject)

              // delete the actual task
              doc.ref.delete()
            })
        } else if (this.$route.name === 'Personal Task List') {
          db
            .collection('personal_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .doc(taskId)
            .get()
            .then(doc => {
              // pass the image object for image deletion operation
              const attachmentObject = doc.data().attachment
              this.openTaskDeletionToast(attachmentObject)

              // delete the actual task
              doc.ref.delete()
            })
        }
      },
      undoTaskDeletion() {
        this.isUndoTaskDeletionClicked = true

        this.$snack.show({
          text: '\"' + this.taskDetails.taskName + '\" has been re-added to the list',
          button: null,
          action: null
        })

        // recover the recently deleted task with updated taskId
        if (this.$route.name === 'Inbox') {
          db
            .collection('inbox_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .add(this.taskDetails)
            .then(docRef => {
              const taskId = docRef.id
              db.collection('inbox_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
                .doc(taskId)
                .update('taskId', taskId)
            })
        } else if (this.$route.name === 'Personal Task List') {
          db
            .collection('personal_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .add(this.taskDetails)
            .then(docRef => {
              const taskId = docRef.id
              db.collection('personal_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
                .doc(taskId)
                .update('taskId', taskId)
            })
        }
      },
      openTaskDeletionToast(attachmentObject) {
        this.isUndoTaskDeletionClicked = false

        this.$snack.show({
          text: '\"' + this.taskDetails.taskName + '\" has been deleted',
          button: 'UNDO',
          action: this.undoTaskDeletion
        })

        setTimeout(() => {
          if (!this.isUndoTaskDeletionClicked) {
            if (attachmentObject !== null) {
              const attachment = attachmentObject.toString()
              const attachmentRef = storage.refFromURL(attachment)

              attachmentRef.delete()

              // reset the undo task deletion clicked state
              this.isUndoTaskDeletionClicked = false
            }
          }
        }, 7500)
      },
      toggleTaskCompleted() {
        const updatedStatus = !this.taskDetails.completed

        if (this.taskDetails.inboxTask) {
          db.collection('inbox_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .doc(this.taskDetails.taskId)
            .update('completed', updatedStatus)
        } else {
          db.collection('personal_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .doc(this.taskDetails.taskId)
            .update('completed', updatedStatus)
        }
      }
    }
  }
</script>

<style scoped>
  .center-align-icon {
    text-align: center;
  }

  .task-completed-toggle {
    font-size: 1.5em;
  }

  .task-completed-toggle:hover {
    cursor: pointer;
  }

  .completed-task-text {
    text-decoration: line-through;
    color: gray;
  }

  .task-priority-icon {
    font-size: 1.5em;
  }

  .task-name-text {
    margin-bottom: 0;
  }

  .task-details-click-area {
    cursor: pointer;
  }

  .task-option-button {
    margin-right: 1em;
  }

  .task-option-button:hover {
    cursor: pointer;
  }

  .delete-task-text {
    margin-bottom: 0;
  }
</style>
